<div class="info-popover flex flex-col items-center justify-center gap-2.5">
  <span class="title">Acabado</span>
  <div class="section flex flex-row gap-2.5">
    <img src="assets/images/finishings/grapado.svg" />
    <div class="flex flex-col">
      <span class="section_title">Grapado</span>
      <span class="section_info"
        >Nuestras máquinas grapan hasta 50 folios. En caso de documentos más grandes, esta opción no está
        disponible.</span
      >
    </div>
  </div>
</div>
